import { useContext } from "react";
import { AppContext } from "../App";
import PopUp from "./PopUp";
import Label from "./Label";
import Allergens from "./Allergens";
import CloseIcon from "./icons/CloseIcon";
import { stripHtml } from "./functions";

function getAllergenName(allergen, lang) {
  if (!allergen) return "";
  if (allergen.translations?.[lang]?.name) return allergen.translations[lang].name;
  if (typeof allergen.translations?.[lang] === "string" && allergen.translations[lang])
    return allergen.translations[lang];
  return allergen.name || "";
}

// Descrizione breve (max 2 righe) del sottoprodotto, solo se abilitata nelle impostazioni menu
export function SubproductDescription({ product }) {
  const { settings, getTranslatedString } = useContext(AppContext);
  if (settings?.menu_api?.show_subproducts_description != 1) return null;
  const description = stripHtml(getTranslatedString(product, "description") || "").trim();
  if (!description) return null;
  return <div className="subproduct-description">{description}</div>;
}

// Icone allergeni del sottoprodotto, sotto nome e descrizione (il tap mostra il nome senza selezionare la riga)
export function SubproductAllergens({ product }) {
  const allergens = product.allergens || [];
  if (allergens.length == 0) return null;
  return (
    <div className="subproduct-allergens" onClick={(e) => e.stopPropagation()}>
      <Allergens allergens={allergens} color="#000" backgroundColor="#e4e4e4" />
    </div>
  );
}

// Tasto info del sottoprodotto
export function SubproductActions({ product, onInfo }) {
  return (
    <div className="subproduct-actions" onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        className="subproduct-info-button"
        onClick={(e) => {
          e.stopPropagation();
          onInfo(product);
        }}
      >
        i
      </button>
    </div>
  );
}

export default function SubproductInfo({ product, onClose }) {
  const { getTranslatedString, lang } = useContext(AppContext);
  const allergens = product.allergens || [];
  const description = getTranslatedString(product, "description");

  return (
    <PopUp size="sm" className="subproduct-info-popup">
      <div className="header">
        <div>{getTranslatedString(product, "name")}</div>
        <button onClick={onClose}>
          <CloseIcon></CloseIcon>
        </button>
      </div>
      <div className="content">
        {product.img && (
          <div className="subproduct-info-img">
            <img src={product.img} />
          </div>
        )}
        {description && (
          <div className="subproduct-info-description" dangerouslySetInnerHTML={{ __html: description }} />
        )}
        {allergens.length > 0 && (
          <div>
            <div className="subproduct-info-title">
              <Label number={22} />
            </div>
            <div className="subproduct-info-allergens">
              {allergens.map((allergen, i) => (
                <div key={i}>
                  <div className="subproduct-allergens">
                    <Allergens allergens={[allergen]} color="#000" backgroundColor="#e4e4e4" />
                  </div>
                  <span>{getAllergenName(allergen, lang)}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </PopUp>
  );
}
